import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { Role } from 'src/app/assabil-kernel/models/entities/master-data/role-entity';
import { Person } from 'src/app/assabil-kernel/models/entities/master-data/person-entity';
import { Branch } from 'src/app/assabil-kernel/models/entities/control-tables/branch-entity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { AssetProduct } from 'src/app/assabil-kernel/models/entities/control-tables/asset-product-entity';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetShipment } from './asset-shipment';



export class AssetAssignment extends BaseEntity {

  assetAssignmentCode         : string;
  partner                     : Partner;
  assetProduct                : AssetProduct;
  theDate                     : Date;	
  branch                      : Branch;
  role                        : Role;
  person                      : Person;  
  progressLevel               : number;
  contractStartDate           : Date;
  contractEndDate             : Date;
  contractSubmitionDate       : Date;
  contractSignatureDate       : Date;
  
  confirmationDate            : Date;
  confirmationRole            : Role;
  confirmationPerson          : Person;

  shipmentForecastDate        : Date;
  assetShipment               : AssetShipment;

  installConfirmationDate     : Date; 
  installConfirmationRole     : Role;   
  installConfirmationPerson   : Person;

  returnRequestDate           : Date;
  returnRequestPerson         : Role;
  returnRequestRole           : Person;

  returnConfirmationDate      : Date;
  returnConfirmationRole      : Role;
  returnConfirmationPerson    : Person;

  expeditionPerson            : Person;

  
  returnForecastDate          : Date;  
  returnDate                  : Date;
  returnValidationDate        : Date;
  returnValidationPerson      : Person;
  returnRole                  : Role;
  returnPerson                : Person;

  asset                       : Asset;
  notes                       : string;
  upAssetAssignment           : AssetAssignment;
  downAssetAssignment         : AssetAssignment;

  constructor() {
    super();

  }
}

	
